import React, { useCallback } from "react";

import { useHistory } from "react-router-dom";

import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import FirestoreImg from "../../../assets/img/cloudFirestore.png";
import ScreenPosts from "../../../assets/img/screen_posts.png";
import ScreenProfil from "../../../assets/img/screen_profil.png";

import GameVignette from "../app/gameVignette";

const HomeContent = (props) => {
  const history = useHistory();

  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      // User is not signed in.
      history.push("./app");
    }
  });

  const AuthFormToggle = useCallback(
    (trigged) => {
      props.setAuthFormTrigger(true);
      trigged(true);
    },
    [props]
  );

  const selectGame = useCallback(
    (game) => {
      props.setSearchGame(game);
      history.push("./search");
    },
    [props, history]
  );

  return (
    <>
      <section className="loud">
        <div className="loud__title">
          <h2>Mate</h2>
          <p>Choisi un jeu et trouve un mate&nbsp;!</p>
        </div>
        <div className="loud__btn">
          <button onClick={(e) => AuthFormToggle(props.setRegisterTrigger)}>
            S'inscrire
          </button>
          <button onClick={(e) => AuthFormToggle(props.setLogInTrigger)}>
            Se connecter
          </button>
        </div>
      </section>

      <div className="interSection">
        <div className="interSection__content container">
          <p>
            Mate c’est une web app sur laquelle tu vas pouvoir rechercher des
            groupes de gamers et t’amuser, t’entrainer ou t'améliorer avec eux.
          </p>
        </div>
      </div>

      <section className="features container">
        <h3 className="features__title">Le plein de fonctionnalités ! </h3>
        <div className="features__content">
          <div className="features__text">
            <h4 className="features__subTitle">Recherche de groupe</h4>
            <p>
              Le site fonctionne avec un système d’annonces. Choisi un jeu,
              découvre les annonces qui y sont associés et rejoint un groupe
              pour pouvoir discuter et jouer avec eux.
            </p>
          </div>
          <img className="features__img" src={ScreenPosts} alt="app annonces" />
        </div>
        <div className="features__content">
          <img
            className="features__img features__img--left"
            src={ScreenProfil}
            alt="app profil"
          />
          <div className="features__text">
            <h4 className="features__subTitle">Profil joueur</h4>
            <p>
              Créer ton profil et personnalise le pour qu’on apprenne à te
              connaître, tu peux également partager tes IDs de plateforme pour
              qu’on te retrouve plus facilement sur Steam, PSN,...
            </p>
          </div>
        </div>
      </section>

      <div className="interSection">
        <div className="container interSection__flex">
          <div className="interSection__content">
            <svg
              className="interSection__img"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Calque 1"
              viewBox="0 0 577 513.9"
            >
              <path
                fill="#fff"
                stroke="#273d4d"
                strokeMiterlimit="10"
                d="M572 0H92a48 48 0 00-48 48v320a48 48 0 0048 48h192l-16 48h-72a24 24 0 000 48h272a24 24 0 000-48h-72l-16-48h192a48 48 0 0048-48V48a48 48 0 00-48-48zm-16 352H108V64h448z"
                transform="translate(-43.5 .5)"
              ></path>
              <path fill="#273d4d" d="M185.3 234.2H404.6V496H185.3z"></path>
              <path
                fill="#fff"
                stroke="#273d4d"
                strokeMiterlimit="10"
                d="M442.2 206.9H231.8a28.7 28.7 0 00-28.7 28.7v248.6a28.7 28.7 0 0028.7 28.7h210.4a28.7 28.7 0 0028.7-28.7V235.6a28.7 28.7 0 00-28.7-28.7zM337 493.8a19.1 19.1 0 1119.1-19.1 19 19 0 01-19.1 19.1zm105.2-64.6a7.23 7.23 0 01-7.2 7.2H239a7.23 7.23 0 01-7.2-7.2V242.7a7.23 7.23 0 017.2-7.2h196a7.23 7.23 0 017.2 7.2z"
                transform="translate(-43.5 .5)"
              ></path>
              <path
                fill="#273d4d"
                stroke="#000"
                strokeMiterlimit="10"
                d="M68.8 304.2H175.1V500.2H68.8z"
              ></path>
              <path
                fill="#fff"
                stroke="#273d4d"
                strokeMiterlimit="10"
                d="M215.5 288.4h-98a21 21 0 00-21 21v182a21 21 0 0021 21h98a21 21 0 0021-21v-182a21 21 0 00-21-21zm-49 210a14 14 0 1114-14 14 14 0 01-14 14zm49-47.3a5.34 5.34 0 01-5.3 5.3h-87.5a5.34 5.34 0 01-5.3-5.3V314.6a5.34 5.34 0 015.3-5.3h87.5a5.34 5.34 0 015.3 5.3z"
                transform="translate(-43.5 .5)"
              ></path>
            </svg>
            <p>Consultable à tout moment sur ordinateur, tablette et mobile.</p>
          </div>
          <div className="interSection__content">
            <img
              className="interSection__img"
              src={FirestoreImg}
              alt="coudFirestore"
            />
            <p>Le tout en temps réel grâce à cloud firestore.</p>
          </div>
        </div>
      </div>

      <section className="gamesList container">
        <h3 className="gamesList__title">
          Maintenant à toi de jouer ! <br />
          <button
            className="gamesList__titleBtn"
            onClick={(e) => AuthFormToggle(props.setRegisterTrigger)}
          >
            Inscris-toi
          </button>
          &nbsp;puis choisi un jeu et trouves toi un Mate !
        </h3>

        <ul className="gamesList__list">
          {props.gamesList &&
            props.gamesList.map((game, key) => (
              <li
                key={key}
                onClick={() => selectGame(game)}
                className="gamesList__el"
              >
                <GameVignette game={game} />
              </li>
            ))}
        </ul>
      </section>
      <footer className="footer">
        <div className="container footer__content">
          <span>
            <a href="https://thibautvermeulen.be/">Thibaut Vermeulen</a>&nbsp;-
            TFE 2020
          </span>

          <a href="http://dwm.re/">Dwm.re</a>
        </div>
      </footer>
    </>
  );
};

export default HomeContent;
